"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@vfuk/core-number-badge"));

var Styled = _interopRequireWildcard(require("./styles/IconSocialPaypal.style"));

var _ruleSet = require("../../ruleSet");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconSocialPaypal = function IconSocialPaypal(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? _ruleSet.nonThemeableRules.defaultSize : _ref$size,
      _ref$isResponsive = _ref.isResponsive,
      isResponsive = _ref$isResponsive === void 0 ? false : _ref$isResponsive,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$inverse = _ref.inverse,
      inverse = _ref$inverse === void 0 ? false : _ref$inverse,
      state = _ref.state,
      numberBadge = _ref.numberBadge;
  return /*#__PURE__*/_react["default"].createElement(Styled.IconWrapper, {
    size: size,
    isResponsive: isResponsive,
    appearance: appearance,
    inverse: inverse,
    state: state
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.695 11.086v-.024a2.837 2.837 0 0 0-1.05-2.187l.046-.21a6.43 6.43 0 0 0 .125-1.25V6.93a3.922 3.922 0 0 0-3.648-3.914.457.457 0 0 0-.125-.016H7.832a1.198 1.198 0 0 0-1.191 1.012L4.312 18.238a.876.876 0 0 0 .875 1.012h3.395l-.207 1.25a.441.441 0 0 0 .375.5h2.781a.701.701 0 0 0 .7-.582l.582-3.57a.765.765 0 0 1 .25-.383.714.714 0 0 1 .374-.133c.723.012.626-.012 1.344 0h.14c.044 0 .067.012.102.012h.04v-.012c2.226-.082 4.636-2.23 4.636-5.145 0-.035-.004-.062-.004-.101Zm-9.363 1.539a.237.237 0 0 0-.074 0h-.02a1.21 1.21 0 0 0-.675.27 1.43 1.43 0 0 0-.465.73l-.012.047-.293 1.75-.5 2.84H5.32l2.305-14.09A.203.203 0 0 1 7.832 4h7.125l.066.008a2.919 2.919 0 0 1 2.79 2.918v.136a7.39 7.39 0 0 1-.051 1.094c-.524 2.73-2.82 4.442-4.75 4.469Zm0 0",
    fill: "none",
    vectorEffect: "non-scaling-stroke"
  })), numberBadge ? /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
    number: numberBadge,
    appearance: inverse ? appearance : 'primary'
  })) : null);
};

IconSocialPaypal.displayName = "IconSocialPaypal";
var _default = IconSocialPaypal;
exports["default"] = _default;
//# sourceMappingURL=IconSocialPaypal.js.map